export enum BaseOrderDirectionEnum {
  asc = 'ASC',
  desc = 'DESC',
}
